import mustache from "mustache";
import juice from "juice";
import { T as THEME } from "./defaults.js";
import "./runtime.js";
import { a as verification_mail_body, b as verification_mail_headline, v as verification } from "./verification_mail_body.js";
import { b as private_env } from "./shared-server.js";
import assert from "node:assert";
import nodemailer from "nodemailer";
const VERIFICATION_TEMPLATE = `<!doctype html>
<html>
	<head>
		<meta name="color-scheme" content="light dark" />
		<meta name="supported-color-schemes" content="light dark" />
		<style>
			body {
				font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
					'Courier New', monospace;
				margin: 0;
				padding: 1px;
				background-color: transparent;
			}

			.container {
				width: 100%;
				max-width: 600px;
				padding: 1px;
				border-radius: 8px;
				margin: 0 auto;
				color: {{color}};
				background-color: {{bg}};

			}


			.header {
				padding: 10px 0px;
				text-align: center;
				text-decoration: underline;
				text-underline-offset: 7px;
				text-decoration-thickness: 5px;
				text-decoration-color: {{accent}};
			}
			.content {
				padding: 29px;
				border-radius: 8px;
				border: 1px;
				/* text-align: center; */
			}

			.code {
				font-size: 36px;
				font-weight: bold;
				text-align: center;
				letter-spacing: 7px;
			}
		</style>
	</head>
	<body>
		<div class="container">
			<div class="header">
				<h1>&nbsp;{{headline}}&nbsp;</h1>
			</div>
			<div class="content">
				<p>{{body}}</p>
				<p class="code">{{key}}</p>
			</div>
		</div>
	</body>
</html>
`;
function objectToFormData(obj) {
  const formData = new FormData();
  Object.entries(obj).forEach(([key, value]) => {
    formData.append(key, value);
  });
  return formData;
}
const mail$3 = (meta) => {
  const url = new URL(`${meta.url}/v3/${meta.domain}/messages`, meta.url);
  return async (data) => {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Basic ${Buffer.from(`${meta.username}:${meta.key}`).toString("base64")}`
      },
      body: objectToFormData(data)
    });
    if (response.status >= 400) {
      console.error(response.statusText);
      console.error(await response.text());
      throw new Error("Error on sending mail with Mailgun");
    }
  };
};
const initMailgun = () => {
  assert(private_env.MAILGUN_API_KEY, "MAILGUN_API_KEY is required");
  assert(private_env.MAILGUN_URL, "MAILGUN_URL is required");
  assert(private_env.MAILGUN_DOMAIN, "MAILGUN_DOMAIN is required");
  const client = {
    username: "api",
    key: private_env.MAILGUN_API_KEY,
    url: private_env.MAILGUN_URL,
    domain: private_env.MAILGUN_DOMAIN
  };
  return {
    mail: mail$3(client)
  };
};
const mail$2 = (meta) => {
  const url = new URL(`/email`, meta.url);
  return async (data) => {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Postmark-Server-Token": meta.token
      },
      body: JSON.stringify({
        From: data.from,
        To: data.to,
        Subject: data.subject,
        HtmlBody: data.html,
        MessageStream: meta.stream
      })
    });
    if (response.status >= 400) {
      console.error(response.statusText);
      console.error(await response.text());
      throw new Error("Error on sending mail with Postmark");
    }
  };
};
const initPostmark = () => {
  assert(private_env.POSTMARK_API_TOKEN, "POSTMARK_API_TOKEN is required");
  const client = {
    token: private_env.POSTMARK_API_TOKEN,
    url: "https://api.postmarkapp.com",
    stream: private_env.POSTMARK_STREAM
  };
  return {
    mail: mail$2(client)
  };
};
const mail$1 = () => {
  const domain = private_env.MAILPIT_DOMAIN ?? "http://localhost:8025";
  const url = new URL("/api/v1/send", domain);
  return async ({ html, from, to, subject }) => {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        accept: "application/json",
        "content-type": "application/json"
      },
      body: JSON.stringify({
        from: {
          Email: from
        },
        to: [
          {
            Email: to
          }
        ],
        html,
        subject
      })
    });
    if (response.status >= 400) {
      throw new Error(`Error on sending mail with Mailpit: ${await response.text()}`);
    }
  };
};
const initMailpit = () => {
  return {
    mail: mail$1()
  };
};
const mail = (transporter) => {
  return async (data) => {
    try {
      const info = await transporter.sendMail(data);
      if (info.rejected.length > 0) {
        throw new Error(` Message rejected: ${info.rejected.join(", ")}`);
      }
    } catch (error) {
      throw new Error(`Error on sending mail via SMTP: ${error}`);
    }
  };
};
const initSMTP = () => {
  assert(private_env.MAIL_HOST, "MAIL_HOST is not set");
  const hasAuth = private_env.MAIL_USER && private_env.MAIL_PASS;
  const isSecure = private_env.MAIL_SECURE ? Boolean(private_env.MAIL_SECURE) : hasAuth;
  const transporter = nodemailer.createTransport({
    host: private_env.MAIL_HOST,
    port: private_env.MAIL_PORT,
    secure: isSecure,
    auth: hasAuth ? {
      user: private_env.MAIL_USER,
      pass: private_env.MAIL_PASS
    } : void 0
  });
  return {
    mail: mail(transporter)
  };
};
const getProvider = () => {
  switch (private_env.MAIL_PROVIDER?.toUpperCase()) {
    case "MAILGUN":
      return initMailgun();
    case "SMTP":
      return initSMTP();
    case "POSTMARK":
      return initPostmark();
    default:
    case "MAILPIT":
      return initMailpit();
  }
};
const provider = getProvider();
const defaultFrom = private_env.MAIL_FROM ?? `noreply@example.com`;
const sendVerificationMail = async (to, key, theme = THEME.DARK) => {
  const html = mustache.render(VERIFICATION_TEMPLATE, {
    bg: theme === THEME.DARK ? "#27272a" : "#f4f4f5",
    color: theme === THEME.DARK ? "#e4e4e7" : "#27272a",
    accent: theme === THEME.DARK ? "#115e59" : "#2dd4bf",
    headline: verification_mail_headline(),
    body: verification_mail_body(),
    key
  });
  const htmlWithInlineStyles = juice(html);
  assert(defaultFrom, "Env MAIL_FROM is required!");
  await provider.mail({
    from: defaultFrom,
    to,
    subject: verification(),
    html: htmlWithInlineStyles
  });
};
export {
  sendVerificationMail as s
};
